import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { SiteNavDropdownColumn } from './SiteNavDropdownColumn';
import { SiteNavDropdownImageModule } from './SiteNavDropdownImageModule';
import styles from './SiteNav-style.scss';

import { type SiteNavDropdownContent_navigationModule$key } from './__generated__/SiteNavDropdownContent_navigationModule.graphql';

type Props = {
    trackingLabelPrefix?: string;
    navigationModule: SiteNavDropdownContent_navigationModule$key;
    isVisible: boolean;
};

export const SiteNavDropdownContent: FC<Props> = ({
    navigationModule: navigationModuleRef,
    trackingLabelPrefix,
    isVisible,
}) => {
    const navigationModule = useFragment(
        graphql`
            fragment SiteNavDropdownContent_navigationModule on NavigationModule {
                name
                items {
                    name
                    column
                    items {
                        name
                    }
                    ...SiteNavDropdownColumn_navigationTopLevel
                }

                imageUrl
                ...SiteNavDropdownImageModule_navigationModule
            }
        `,
        navigationModuleRef
    );

    const { imageUrl, items } = navigationModule;
    const columns: Record<string, NonNullable<typeof items>[number][]> = {};
    let imageModule;

    // Group columns by column number
    items?.forEach(item => {
        if (item?.column) {
            if (!columns[item.column]) {
                columns[item.column] = [];
            }
            columns[item.column].push(item);
        }
    });

    if (imageUrl) {
        imageModule = (
            <div className={`${styles.dropdownCol} ${styles.imageModule}`}>
                <SiteNavDropdownImageModule
                    navigationModuleRef={navigationModule}
                    isVisible={isVisible}
                />
            </div>
        );
    }

    return (
        <div className={styles.dropdownContent}>
            {Object.values(columns).map(
                itemCol =>
                    itemCol && (
                        <SiteNavDropdownColumn
                            key={itemCol.map(item => item?.name).join()}
                            navigationItems={itemCol.filter(
                                (item): item is NonNullable<typeof item> => item !== null
                            )}
                            trackingLabelPrefix={trackingLabelPrefix || ''}
                        />
                    )
            )}
            {imageModule}
        </div>
    );
};
